import React, { useEffect, useState } from "react";

// Slides Data
const slides = [
  {
    title: "Custom Software Development",
    desc:
      "Tailored software solutions built to streamline operations and solve complex business challenges.",
    bg: "bg-[url('/assets/images/home-slides/c2.jpg')] bg-cover bg-center",
    link: "/services/custom-software-development",
  },
  {
    title: "Mobile Application Development",
    desc:
      "Gets in sync with the unstoppable growing pace of mobile application market.",
    bg: "bg-[url('/assets/images/home-slides/slide-2.jpg')] bg-cover bg-center",
    link: "/services/mobile-app-development",
  },
  {
    title: "API Development",
    desc:
      "Robust and secure API solutions to power your integrations, apps, and services across platforms.",
    bg: "bg-[url('/assets/images/home-slides/c1.jpg')] bg-cover bg-center",
    link: "/services/api-development",
  },
  {
    title: "Integration",
    desc:
      "Unifying systems and technologies to ensure seamless data flow and operational efficiency.",
    bg: "bg-[url('/assets/images/home-slides/slide-1.jpg')] bg-cover bg-center",
    link: "/services/integration",
  },
  {
    title: "Data Analytics",
    desc:
      "Unlock actionable insights with our advanced analytics solutions for better decision-making.",
    bg: "bg-[url('/assets/images/home-slides/c3.jpg')] bg-cover bg-center",
    link: "/services/data-analytics",
  },
  {
    title: "Big Data",
    desc:
      "Scalable big data architecture and processing to handle vast information and drive business growth.",
    bg: "bg-[url('/assets/images/home-slides/slide-3.jpg')] bg-cover bg-center",
    link: "/services/big-data",
  },
  {
    title: "AI, ML & GEN AI",
    desc:
      "Innovative solutions leveraging artificial intelligence, machine learning, and generative AI for automation and personalization.",
    bg: "bg-[url('/assets/images/home-slides/c4.jpg')] bg-cover bg-center",
    link: "/services/ai-ml-genai",
  },
  {
    title: "SAP Services",
    desc:
      "Expert SAP solutions including BTP and SuccessFactors to transform your enterprise operations.",
    bg: "bg-[url('/assets/images/home-slides/c5.jpg')] bg-cover bg-center",
    link: "/services/sap-services",
  },
  {
    title: "Odoo Services",
    desc:
      "Providing comprehensive Odoo ERP solutions tailored to your business needs.",
    bg: "bg-[url('/assets/images/home-slides/c6.jpg')] bg-cover bg-center",
    link: "/services/odoo-services",
  },
];

export default function HeaderArea() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000); // auto change every 5s
    return () => clearInterval(timer);
  }, []);

return (
  <header className="relative w-full h-screen overflow-hidden bg-black">
    {/* Slides */}
    {slides.map((slide, index) => (
      <div
        key={index}
        className={`absolute inset-0 transition-opacity duration-1000 ease-in-out 
          ${index === current ? "opacity-100 z-20" : "opacity-0 z-0"} 
          ${slide.bg || ""}`}
      >
        {/* Optional dark overlay */}
        <div className="absolute inset-0 bg-black/80" />

        {/* Slide Content */}
        <div className="relative z-30 flex flex-col items-center justify-center h-full text-center px-6">
          {/* Heading */}
          <h1
            className={`text-4xl md:text-6xl font-bold text-white transition-all duration-1000 mb-4 
              ${
                index === current
                  ? "opacity-100 translate-y-0 delay-200"
                  : "opacity-0 translate-y-10"
              }
            `}
          >
            {slide.title}
          </h1>

          {/* Subheading */}
          <h4
            className={`mt-4 text-lg md:text-2xl text-gray-200 transition-all duration-1000 mb-10
              ${
                index === current
                  ? "opacity-100 translate-y-0 delay-500"
                  : "opacity-0 translate-y-10"
              }
            `}
          >
            {slide.desc}
          </h4>

          {/* Button */}
          <div
            className={`mt-6 transition-all duration-1000 mt-10
              ${
                index === current
                  ? "opacity-100 translate-y-0 delay-700"
                  : "opacity-0 translate-y-10"
              }
            `}
          >
            <a
              href={slide.link}
              className="px-6 py-3 bg-white/10 border border-white/30 text-white font-medium rounded-lg backdrop-blur-md hover:bg-white/20 hover:border-white/50 shadow-lg transition duration-300"
            >
              Read More
            </a>
          </div>
        </div>
      </div>
    ))}

    {/* Indicators */}
    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-3 z-40">
      {slides.map((_, index) => (
        <button
          key={index}
          onClick={() => setCurrent(index)}
          className={`w-3 h-3 rounded-full transition 
            ${index === current ? "bg-white" : "bg-gray-400"}`}
        />
      ))}
    </div>
  </header>
);

}
